import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  bcpDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './delete-schematics-dialog.controller';
import template from './delete-schematics-dialog.html';

class dialogService {
  getOptions($event, { assessmentId, mainOfficeSchematics, branchSchematics, disasterRecoverySchematics }) {
    return {
      controller,
      controllerAs: 'deleteSchematicsDialogVM',
      locals: {
        assessmentId,
        mainOfficeSchematics,
        branchSchematics,
        disasterRecoverySchematics,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.schematics.deleteSchematicsDialog', [
  ngCookies,
  constants,
  bcpDataService,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
])
  .service('deleteSchematicsDialog', dialogService)
  .name;
